<template>
    <v-card outlined :loading="isTranslating">

        <v-card-text :class="{ 'pt-5': isTranslating }">
            <div class="text-h6 mb-3">
                <v-icon>
                    {{ icons.mdiWeb }}
                </v-icon>
                {{ $t('Automaattinen käännös') }}

            </div>
            <p v-html="$t('deepl_notice')">
            </p>
            <div class="d-flex align-start">
                <img :src="current.icon" style="max-height: 24px" class="mr-3" />
                <v-icon class="mr-3">
                    {{ icons.mdiArrowRight }}
                </v-icon>

                <template v-for="otherLang in otherLanguages">
                    <v-checkbox class="ma-0 pa-0" v-model="selected" :value="otherLang.code">
                        <template #label>
                            <img :src="otherLang.icon" style="max-height: 24px" class="mr-3" />
                        </template>
                    </v-checkbox>
                </template>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="translate" small :loading="isTranslating">
                <v-icon class="mr-2">
                    {{ icons.mdiWeb }}
                </v-icon>
                {{ $t('Suorita käännös') }}
            </v-btn>
        </v-card-actions>
        <v-card-text v-if="errors.length">
            <v-alert color="error" text>
                <div v-for="error in errors" :key="error">
                    {{ error }}
                </div>
            </v-alert>
        </v-card-text>
    </v-card>
</template>
<script>
import {
    mdiArrowRight,
    mdiWeb
} from "@mdi/js";

import { onMounted, reactive, ref, computed } from "@vue/composition-api";


export default {
    props: ['languages', 'current', 'isTranslating', 'errors'],
    setup(props, context) {

        const selected = ref([]);

        const translate = () => {
            context.emit("click", props.current.code, selected.value);
        }

        const otherLanguages = computed(() => {
            return props.languages.filter(l => l.code !== props.current.code);
        });

        onMounted(() => {
            selected.value = props.languages.filter(l => l.code !== props.current.code).map(l => l.code);
        });

        return {
            selected,
            translate,
            otherLanguages,
            icons: {
                mdiArrowRight,
                mdiWeb
            }
        }
    }
}
</script>